import React from 'react';

export type ChipButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  label?: string;
};

export const ChipButton: React.FC<ChipButtonProps> = ({
  label,
  children,
  className = '',
  style,
  ...buttonProps
}) => {
  return (
    <button
      {...buttonProps}
      className={`relative overflow-hidden py-2.5 px-3 rounded-full font-bold text-sm transition-all disabled:opacity-60 disabled:cursor-not-allowed ${className}`}
      style={{
        background: 'linear-gradient(135deg, #f9fafb, #e5e7eb, #d1d5db)',
        borderWidth: '3px',
        borderColor: 'rgba(156, 163, 175, 0.6)',
        color: '#1f2937',
        boxShadow: '0 2px 6px rgba(0,0,0,0.18)',
        ...(style || {})
      }}
    >
      <div className="absolute inset-0.5 rounded-full border border-dashed border-gray-400/30 pointer-events-none" />
      <span className="relative">{children ?? label}</span>
    </button>
  );
};

